import Category from '@/models/Category';
import { Family } from '@/models/Family';
import Tag from '@/models/Tag';
import * as Yup from 'yup';

export interface ProgramForm {
    mainImage?: string;
    type: string;
    name: string;
    author: string;
    description?: string;
    locale: string;
    categories: Category[];
    tags: Tag[];
    families?: Family[];
}

export const programSchema: Yup.ObjectSchema<ProgramForm> = Yup.object().shape<ProgramForm>({
    mainImage: Yup.string().required(),
    type: Yup.string().required(),
    name: Yup.string().required(),
    author: Yup.string().required(),
    description: Yup.string().notRequired(),
    locale: Yup.string().required(),
    categories: Yup.array<Category>().min(1),
    tags: Yup.array<Tag>().min(1),
    families: Yup.array<Family>().notRequired(),
});

export const formInitialState = {
    mainImage: '',
    type: '',
    name: '',
    author: '',
    description: '',
    locale: '',
    categories: [],
    tags: [],
    families: [],
};
